import { useEffect, useRef, useState } from "react";
import { Row, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import TabelaListagemFichas from "../../../../components/TabelaListagemFichas/TabelaListagemFichas";

export default function HistoricoVisualizacoes({ infracao, showDivs }) {
    const [openHistoricoVisualizacoes, setOpenHistoricoVisualizacoes] = useState(false);
    const contentRef = useRef(null);

    //Cabeçalhos que a tabela terá
    const headersListaHistoricoAcesso = [
        { value: "Email", objectValue: "email", align: "left" },
        { value: "IP", objectValue: "ip", align: "left" },
        {
            value: "DATA/HORA",
            objectValue: "dataHora",
            formatDate: true,
            align: "left",
        },
    ];

    useEffect(() => {
        setOpenHistoricoVisualizacoes(showDivs);
    }, [showDivs]);

    if (!infracao?.historicosAcessoExterno?.length) return null;

    return (
        <div className="break mt-4 shadowFicha rounded-3">
            <div
                className="d-flex justify-content-between align-items-center p-2 titleFicha"
                style={{ cursor: "pointer" }}
                onClick={() => setOpenHistoricoVisualizacoes(!openHistoricoVisualizacoes)}
            >
                <h5 className="mb-0">Histórico de Visualizações</h5>
                {!showDivs && openHistoricoVisualizacoes && <FontAwesomeIcon icon={faChevronUp} size="lg" />}
                {!showDivs && !openHistoricoVisualizacoes && <FontAwesomeIcon icon={faChevronDown} size="lg" />}
            </div>

            <div
                ref={contentRef}
                className="collapse-content"
                style={{
                    maxHeight: openHistoricoVisualizacoes
                        ? `${contentRef.current?.scrollHeight}px`
                        : "0px",
                }}
            >
                <Row className="px-3 py-2">
                    <Col md="12" className="mb-2">
                        <TabelaListagemFichas
                            headers={headersListaHistoricoAcesso}
                            items={infracao?.historicosAcessoExterno}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
}
